import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar-toggle"
export default class extends Controller {
  static targets = ["sidebar"]

  toggle() {
    if (window.innerWidth <= 1024) {
      this.sidebarTarget.classList.toggle('is-open')
    } else {
      this.sidebarTarget.classList.toggle('is-collapsed')
      this.element.classList.toggle('sidebar-collapsed')
    }
  }
}
